module.exports = __webpack_public_path__ + "img/top_safe05.2523287e.png";